import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { ArrowRightOutlined } from '@ant-design/icons';
import UserAvatarColumn from './UserAvatarColumn';
import TextColumn from './TextColumn';
import ActivityTagColumn from './ActivityTagColumn';
import TimeColumn from './TimeColumn';
import { SingleAssetAuditResult } from '../../../../../../types.generated';
import i18n from '../../../../../../i18n/i18n';

function getValue(value) {
    return value?.replace(/&nbsp;/g, ' ');
}

export const getColumns = (): ColumnsType<SingleAssetAuditResult> => [
    {
        title: i18n.t('Time'),
        dataIndex: 'time',
        key: 'time',
        width: '12%',
        render: (value) => <TimeColumn value={value} />,
    },
    {
        title: i18n.t('Activity'),
        key: 'activity',
        width: '8%',
        dataIndex: 'activity',
        render: (activity) => <ActivityTagColumn activity={activity} />,
    },
    {
        title: i18n.t('Attribute'),
        dataIndex: 'attribute',
        key: 'attribute',
        width: '10%',
    },
    {
        title: i18n.t('Old Value'),
        dataIndex: 'oldValue',
        key: 'oldValue',
        width: '10%',
        render: (value) => <TextColumn value={value} />,
    },
    {
        title: <div style={{ display: 'none' }}>{i18n.t('Changed to')}</div>,
        dataIndex: 'arrowIcon',
        key: 'arrowIcon',
        width: '5%',
        align: 'center',
        render: () => <ArrowRightOutlined className="f-color-dark-black-s30" />,
    },
    {
        title: i18n.t('New Value'),
        dataIndex: 'newValue',
        key: 'newValue',
        width: '10%',
        render: (value) => <TextColumn value={getValue(value)} />,
    },
    {
        title: i18n.t('Message'),
        dataIndex: 'message',
        key: 'message',
        width: '30%',
        fixed: true,
        render: (value) => <TextColumn value={value} />,
    },
    {
        title: i18n.t('User'),
        dataIndex: 'user',
        key: 'user',
        width: '15%',
        render: (userUrn) => <UserAvatarColumn userUrn={userUrn} />,
    },
];
